import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { Button, EmptyState } from '@lp/portal-ui';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <EmptyState
      title="找不到此頁"
      description="網址可能有誤，或頁面已被移除。"
      action={
        <Button variant="secondary" onClick={() => navigate('/')}>
          返回主控台
        </Button>
      }
    />
  );
}

/** Shown when a page throws while rendering. */
export function RouteErrorPage() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <div className="max-w-md rounded-2xl bg-white p-8 text-center ring-1 ring-line">
        <h1 className="text-lg font-medium text-ink">{notFound ? '找不到此頁' : '頁面出現問題'}</h1>
        <p className="mt-2 text-sm text-muted">{notFound ? '網址可能有誤。' : '請重新載入頁面；如問題持續，請聯絡 LoyaltyPlus 支援。'}</p>
        <div className="mt-5 flex justify-center gap-2">
          <Button variant="secondary" onClick={() => window.location.reload()}>
            重新載入
          </Button>
          <Button onClick={() => window.location.assign('/')}>返回主控台</Button>
        </div>
      </div>
    </div>
  );
}
